// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  import styles                 from './style'
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../../services/fetchTools';
  import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../../components';
  import { withRouter } from 'react-router';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  import styled from 'styled-components'
  import FlatButton from 'material-ui/FlatButton';
  import Dialog from 'material-ui/Dialog'
  import ReactTable from "react-table";
  import { Spinner } from 'react-activity';
  import 'react-activity/dist/react-activity.css';
  import * as actions           from '../../../../redux/modules/actions';
  
  class CheckinOut extends PureComponent {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        checklist_records:{'checkin_records':[],'checkout_records':[]},
        Activity_details:[],
        viewBotton:false,
        apporvedButton:false,
        selected_activity:'',
        activity_state:true,
        checkList_data:[],
        checkList_headers:[],
        venue:'',
        date:moment(),
        program_date_changed:false,
      };
      this.get_Activity_details = this.get_Activity_details.bind(this);
      this.handleClose = this.handleClose.bind(this);
      this.get_Checklist_Records = this.get_Checklist_Records.bind(this);
      this.confirmAprooved = this.confirmAprooved.bind(this);
      this.postActivityStatus = this.postActivityStatus.bind(this);
      this.getCheckInOutDetails = this.getCheckInOutDetails.bind(this);
      this.renderCheckList = this.renderCheckList.bind(this);
  
    }
    
  
    componentDidMount() {
        this.get_Activity_details()
        this.getCheckInOutDetails()
        
    }

    getCheckInOutDetails() {
    const date = this.state.date.format('YYYY-MM-DD');
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=5100&venue_id=${this.state.venue}&date=${date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({checkList_data:data.data,checkList_headers:data.headers,venue:data.venue_id,program_date_changed:false})
           // alert("fix");
       }).catch(error => error);
    }

    postActivityStatus(){
            
            const url = `${getLocationOrigin()}/cm/confirm_activity_tracker/`;

            const options = {...defaultOptions};
            options['method'] = 'post';
            options['headers'] = {'content-type': 'application/json'}
            options['body'] = JSON.stringify({
                                'activity_tracker_id': this.state.selected_activity.activity_record.id,
                                'sub_object_id': this.state.selected_activity.checkin_detail.id

                            });
            return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then((response) =>   {   this.setState({apporvedButton:false}),
                                        window.location.reload();            
                })
            .catch((error) => {
                console.log(error);
                alert(error.message);
                
            });
    }

    confirmAprooved(activity){
        this.setState({apporvedButton:true,selected_activity:activity})
    }

    get_Checklist_Records(activity_record){
        
        var date = activity_record.date
        var buddy_id = activity_record.object_id.id
        var venue_id = activity_record.venue.id
        
        const url = `${getLocationOrigin()}/cm/get_checklist_details/?venue_id=${venue_id}&buddy_id=${buddy_id}&date=${date}`;
        const options = {...defaultOptions};
    
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({ checklist_records: data.checklist_records}),
                            this.setState({viewBotton:true}),
                    console.log("data")
            )
           .catch(error => error);
    }

    handleClose(){
        this.setState({viewBotton:false,apporvedButton:false})
    }
  
    get_Activity_details(){
        const url = `${getLocationOrigin()}/cm/get_activity_details`;
        const options = {...defaultOptions};

        return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            this.setState({Activity_details:data.Activity_details,activity_state:false});
        }).catch(error => error);
    }

    renderCheckList(){
   
    var headers = []
    if(this.state.checkList_data.length > 0){
      headers = Object.keys(this.state.checkList_data[0])
    }
    
    const headings = this.state.checkList_headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = index.toString();//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });

    return(
      <div className='col-md-12 table_container1 table-responsive'>
        <div className="heading heading2 left">Collection Details </div> 
        { this.state.checkList_data.length > 0 ?
          <ReactTable  
                      data={this.state.checkList_data}  
                      columns={headings}  
                      defaultPageSize = {25}  
                      pageSizeOptions = {[25,50,75,100]} 
                      filterable={true}
                      showPagination={this.state.checkList_data.length > 25}
                      showPaginationTop = {this.state.checkList_data.length > 25}
                      style = {{background:'#9370DB'}}
                      getTrProps = {this.getTrProps}
                      defaultFilterMethod = {(filter, row, column) => {
                        const id = filter.pivotId || filter.id
                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                      }}
                     
          />
          :
          this.state.checkList_headers.length > 0 ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
            </div>
            :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
        }
      </div>
      )
  }
  
    render() {


    console.log('props data',this.state.game_type)
    return(
      <div>
        <div>
            
          {this.renderCheckList()}
        </div>
      </div>
    );



    //   var venue = this.state.venue;
    // if(this.state.checkList_data.length == 0 && this.state.checkList_headers.length == 0 || this.state.program_date_changed){
    //   this.getCheckInOutDetails()
    // }
    
    // return(
    //   <div className='col-md-12 table_container1' style={styles.table}>
    //     <div className="heading heading2 left" style={styles.header}>Bookings By Program</div> 
    //     <div style={{display:'flex',margin:'1%'}}>
    //       <div> Date - </div>
    //       <DatePicker selected={this.state.date} onChange={this.handleDate}/>
    //     </div>
    //     <table className="table_plain">
    //       <tr> 
    //         {this.state.checkList_headers.map((head)=>
    //           <th>{head}</th>
    //         )
    //       }
    //       </tr>
          
    //         { this.state.checkList_data && this.state.checkList_data.length > 0 ?
    //           this.state.checkList_data.map((data)=>
    //             <tr>
    //               { data.map((each)=>
    //                 <td dangerouslySetInnerHTML={{__html:each}}></td>
    //                 )
    //               }
    //             </tr>
    //             )
    //           :
              
    //           this.state.checkList_headers.length > 0 ?
    //           <div style={{height:500}}>
    //             <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
    //           </div>
    //           :
    //           <div style={{height:500}}>
    //             <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
    //           </div>
              
    //         }

    //     </table>
    //   </div>
    //   )
      //   console.log(this.state)
      //   const okaction = [
      //   <FlatButton
      //     label="OK"
      //     primary={true}
      //     onClick={this.handleClose}
      //   />
      // ];
      //   const dialog_actions = [
      //   <FlatButton
      //     label="Cancel"
      //     primary={true}
      //     onClick={this.handleClose}
      //   />,
      //   <FlatButton
      //     label="Approve"
      //     primary={true}
      //     onClick={this.postActivityStatus}
      //   />,
      // ];
        
      //   var serial_no = 1;
      // return(
      //   <div style={styles.container}>
      //       <div className="col-md-12" style={{'margingTop':20,'padding':10,'display':"flex",'flexDirection':"row",'backgroundColor':"#C993FF"}}>
      //             <div className="col-md-2" >
      //               SI.No.
      //             </div>
                  
      //             <div className="col-md-2" >
      //               Date
      //             </div>  
                  
      //             <div className="col-md-2" >
      //               Name
      //             </div>
                  
      //             <div className="col-md-2" >
      //               Role
      //             </div>
      //             <div className="col-md-2" >
      //               Check In
      //             </div>
      //             <div className="col-md-2" >
      //               Check Out
      //             </div>
      //             <div className="col-md-2" >
      //               CheckList
      //             </div>
      //             <div className="col-md-2" >
      //               Status
      //             </div>
      //       </div>
      //       {this.state.activity_state ? 
      //       <div style={{position:'absolute',marginTop:'30%',marginLeft:'40%'}}>
      //           <Spinner size="50" />
      //       </div>
      //       :
      //       this.state.Activity_details.map((activity,index) =>
      //           <div className="col-md-12" style={{'padding':10,'display':"flex",'flexDirection':"column",'backgroundColor':"white",'marginTop':"2px"}}>
      //               <div style={{'display':"flex",'flexDirection':"row"}}>
      //                   <div className="col-md-2" >
      //                       {serial_no ++}
      //                   </div>
      //                   <div className="col-md-2" >
      //                       {activity.activity_record.date}
      //                   </div>
      //                   <div className="col-md-2" >
      //                       {activity.activity_record.object_id.name}
      //                   </div>
      //                   <div className="col-md-2" >
      //                       {activity.activity_record.object_id.role}
      //                   </div>
      //                   <div className="col-md-2" >
      //                   {activity.checkin_detail ?
      //                       <div>
      //                       {activity.checkin_detail.time}
      //                       </div>:
      //                       <div>
      //                       --
      //                       </div>
      //                   }
      //                   </div>
      //                   <div className="col-md-2" >
      //                   {activity.checkout_detail ?
      //                       <div>
      //                       {activity.checkout_detail.time}
      //                       </div>:
      //                       <div>
      //                       --
      //                       </div>
      //                   }
      //                   </div>
      //                   <div className="col-md-2" >
      //                       <input type="button" value="view" style={{'fontSize':"18px"}} onClick={()=>{this.get_Checklist_Records(activity.activity_record)}} />
      //                       {this.state.viewBotton &&
      //                           <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
      //                               <Dialog
      //                               actions={okaction}
      //                               modal={false}
      //                               open={this.state.viewBotton}
      //                               onClick={this.handleClose}
      //                               autoDetectWindowHeight={true}
      //                               autoScrollBodyContent={true}
      //                               scroll={scroll}
      //                               dividers={scroll === 'paper'}
      //                               >
      //                                   <div style={styles.main_header} className="col-md-12">
      //                                     <h4 style={{textAlign:'center'}}>CheckIn and CheckOut Detail</h4>
      //                                   </div>
      //                                   <div className="col-md-12" style={{'textAlign':"center",'color':"blue"}}>
      //                                       <h2>CheckIn Records</h2>
      //                                   </div>
      //                                   <div className="col-md-12" style={{'display':"flex",'flexDirection':"row",'textAlign':"center",'backgroundColor':"#C9B7FF",'fontSize':"20px"}}>
      //                                       <div className="col-md-6">
      //                                           <label> Task Name </label>
      //                                       </div>
      //                                       <div className="col-md-6">
      //                                           <label> Response </label>
      //                                       </div>
      //                                   </div>
      //                                   {this.state.checklist_records.checkin_records.map((checkin,index) =>
      //                                       <div className="col-md-12" style={{'display':"flex",'flexDirection':"row",'textAlign':"center",'backgroundColor':"#FFFDCE",'marginTop':"1px"}}>
      //                                               <div className="col-md-6">{checkin.task.name}
      //                                               </div>
      //                                               <div className="col-md-6">{checkin.response}
      //                                               </div>
                                                    
                                                
      //                                       </div>
      //                                   )}
      //                                   <div className="col-md-12" style={{'textAlign':"center",'color':"blue"}}>
      //                                           <h2>CheckOut Records</h2>
      //                                   </div>
      //                                   <div className="col-md-12" style={{'display':"flex",'flexDirection':"row",'textAlign':"center",'backgroundColor':"#C9B7FF",'fontSize':"20px"}}>
      //                                       <div className="col-md-6">
      //                                           <label> Task Name </label>
      //                                       </div>
      //                                       <div className="col-md-6">
      //                                           <label> Response </label>
      //                                       </div>
      //                                   </div>
      //                                   {this.state.checklist_records.checkout_records.map((checkout,index) =>
      //                                       <div className="col-md-12" style={{'display':"flex",'flexDirection':"row",'textAlign':"center",'backgroundColor':"#FFFDCE",'marginTop':"1px"}}>
      //                                               <div className="col-md-6" >{checkout.task.name}
      //                                               </div>
      //                                               <div className="col-md-6">{checkout.response}
      //                                               </div>
                                                    
                                                
      //                                       </div>
      //                                   )}
                                        
      //                               </Dialog>
      //                           </div>
      //                       }
      //                   </div>
      //                   <div className="col-md-2" >
      //                       <input type="button" value="Approve" style={activity.activity_record.status == 'Approved' ? {'backgroundColor':"#48CB60"}:{'backgroundColor':"red",'fontSize':"18px"}}  onClick={()=>{this.confirmAprooved(activity)}} />
      //                       {this.state.apporvedButton &&
      //                           <Dialog
      //                             actions={dialog_actions}
      //                             modal={false}
      //                             open={this.state.apporvedButton}
      //                             onClick={this.handleClose}
      //                             autoDetectWindowHeight={true}
      //                             autoScrollBodyContent={true}
      //                             scroll={scroll}
      //                             dividers={scroll === 'paper'}
      //                           >

      //                           <div className="col-md-12">
      //                             <h3 style={{textAlign:'center','color':"Green"}}>
      //                             Do you want to Approved??
      //                             </h3>
      //                           </div>
      //                           </Dialog>
      //                         }
      //                   </div>

      //               </div>
      //           </div>
      //       )}
            
            
      //   </div>
      // );
    }
  }
  
  export default CheckinOut;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/checkInOut/index.js